(() => {
  const target = document.querySelector('.product-details > form .cta-buttons');
  const ctaBtn  = document.querySelector('.product-details > form .cta-buttons'); // change this to the element you want to add class on
  if (!target || !ctaBtn) return;

  const ACTIVE_CLASS = 'cta-out-of-view';

  const io = new IntersectionObserver(
    ([entry]) => {
      const method = entry.isIntersecting ? 'remove' : 'add';
      ctaBtn.classList[method](ACTIVE_CLASS);
    },
    { threshold: 0.01, rootMargin: '0px' }
  );

  io.observe(target);
})();


document.addEventListener('DOMContentLoaded', function() {

class UpsellCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Swiper cannot build a loop from a single slide: it re-snaps forever.
    var slideCount = this.querySelectorAll('.swiper-slide').length;

    new Swiper(this, {
      slidesPerView: 1,
      spaceBetween: 12,
      loop: slideCount >= 2,
      watchOverflow: true,
      navigation: {
        nextEl: this.querySelector(".cart-upsell-next"),
        prevEl: this.querySelector(".cart-upsell-prev"),
      },
    });
  }
}

customElements.define('upsell-cart', UpsellCart);


document.addEventListener("DOMContentLoaded", function() {
  CartDrop(true);
});



    class JciUpsellSwiper extends HTMLElement {
      connectedCallback() {
        if (typeof Swiper === 'undefined') return;

        // Loop mode needs at least twice the number of visible slides to build a
        // stable duplicate set. Desktop shows 4, so fewer than 8 slides sends
        // loopFix() into an endless re-snap and the row visibly oscillates.
        var slideCount = this.querySelectorAll('.swiper-slide').length;

        new Swiper(this, {
          slidesPerView: 2,
          spaceBetween: 16,
          loop: slideCount >= 8,
          watchOverflow: true,
          centerInsufficientSlides: true,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            768: {
              slidesPerView: 4,
              spaceBetween: 24,
            }
          }
        });
      }
    }

    if (!customElements.get('jci-upsell-swiper')) {
      customElements.define('jci-upsell-swiper', JciUpsellSwiper);
    }
  });
